export default __webpack_public_path__ + "static/food-cutting-screen-cf62e8fee3e23ee26e6b08c82773e5ce.svg";